const aaa = [
	{
		path: "goods",
		component: () => import("@/views/goods/list.vue"),
		meta:{title:'商品配置'},
	},
	{
		path: "addGoods",
		component: () => import("@/views/goods/addGoods.vue"),
		meta:{title:''},
	}
]
export default aaa;